import React, {
  useContext,
  useMemo,
  useState
} from 'react';

const AssayLoadingContext = React.createContext({
  assayPreviewLoading: false,
  setAssayPreviewLoading: () => { },
});

export const AssayLoadingProvider = ({
  children
}) => {
  const [assayPreviewLoading, setAssayPreviewLoading] = useState(false);

  const assayLoadingContextValue = useMemo(() => ({
    assayPreviewLoading,
    setAssayPreviewLoading
  }), [
    assayPreviewLoading,
    setAssayPreviewLoading
  ])

  return (
    <AssayLoadingContext.Provider value={assayLoadingContextValue}>
      {children}
    </AssayLoadingContext.Provider>
  )
}

export const useAssayLoadingContext = () => useContext(AssayLoadingContext);

export default useAssayLoadingContext;
